import { localhost } from "./server_url";
const apiURL = "/api";

export const endpoint = `${localhost}${apiURL}`;

export const authURL = `${endpoint}/verify_token_login/`;
export const loginURL = `${endpoint}/token/`;
export const logoutURL = `${endpoint}/logout/`;
export const token_refresh_URL = `${endpoint}/token/refresh/`;
export const registerURL = `${endpoint}/rest-auth/registration/`;
// export const userURL = id => `${endpoint}/user/${id}`;// Error
export const userURL = (id) => `${endpoint}/usermmanager/${id}`;
export const userCreateURL = `${endpoint}/usermmanager/`;
// export const userCreateURL = `${endpoint}/user`;// Error
export const usersCanAcceptListURL = `${endpoint}/list_useraccept/`;
export const usersCanProcessListURL = `${endpoint}/list_users_can_process/`;

// export const teamListURL  = `${endpoint}/teamlistview`;// Error
export const teamListURL = `${endpoint}/list_team/`;
// Error userPermission && userPermission.includes('can_create')
// export const chucvuListURL  = `${endpoint}/chucvulistview`;
export const chucvuListURL = `${endpoint}/list_chucvu/`;

// export const nhomQuyenListURL = `${endpoint}/nhomquyen`;// Error
export const listVanphong = `${endpoint}/list_vanphong/`;
export const listCustomer = `${endpoint}/list_customer/`;

export const listBophansudung = `${endpoint}/list_bophan_sudung/`;
export const bophansudungURL = (id) => `${endpoint}/bophanmmanager/${id}`;
export const createBophansudungURL = `${endpoint}/bophanmmanager/`;
export const editBophansudungURL = (id) => `${endpoint}/bophansudung/${id}`; // Error
// export const createBophansudungURL = `${endpoint}/bophansudung`;// Error

export const listBophanxuly = `${endpoint}/list_handling_group/`;
export const bophanxulyURL = (id) => `${endpoint}/handlinggroupmmanager/${id}`;
export const createBophanxuly = `${endpoint}/handlinggroupmmanager/`;
export const editBophanxulyURL = (id) => `${endpoint}/bophanxuly/${id}`; // Error
// export const createBophanxuly = `${endpoint}/bophanxuly`;// Error

export const editLoaiyeucauURL = (id) => `${endpoint}/tickettypemmanager/${id}`;
export const createLoaiyeucau = `${endpoint}/tickettypemmanager/`;
// export const editLoaiyeucauURL = id => `${endpoint}/typerequestmanager/${id}`;// Error
// export const createLoaiyeucau = `${endpoint}/typerequestmanager`;// Error
export const listLoaiyeucauall = `${endpoint}/list_ticket_type/`;
// export const listLoaiyeucauall = `${endpoint}/list_loaiyeucau/`;// Error

export const listFileAttach = (id) =>
  `${endpoint}/file_attach/?ticket_rel=${id}`;
export const ticketChangeState = `${endpoint}/tickets/changestatus`;
export const checkFileAttach = `${endpoint}/tickets/checkfileblank`;
export const ListAction = `${endpoint}/tickets/viewticketdetail`;
export const ListCommentURL = `${endpoint}/tickets/viewlistcomment`;

export const getReports = `${endpoint}/tickets/reportlistview`;
export const getExportExcelReport = `${endpoint}/tickets/reportexportexcel`;
export const exportTicketType = `${endpoint}/export_ticket_type`;

export const viewReports = `${endpoint}/report`;
export const exportExcelReport = `${endpoint}/export_excel`;
export const exportExcelUser = `${endpoint}/export_user`;

export const userIDURL = `${endpoint}/list_permission/`;
export const ListNotification = `${endpoint}/list_notification/`;
// export const getAttachmentTemplate = (id) => `${endpoint}/ticket_type/${id}`;
export const listLoaiyeucau = (group_xuly) =>
  `${endpoint}/list_tickettype/?handling_group=${group_xuly}`;
export const listHandlingLoaiyeucau = `${endpoint}/list_handling_tickettype/`;
export const listAllLoaiyeucau = `${endpoint}/list_handling_alltickettype/`; // Dùng cho page Tất cả yêu cầu

export const listLoaiyeucauAll = `${endpoint}/list_tickettype/`; // trống
export const ticketCreate = `${endpoint}/ticket_manager`;
export const ticketUpdateFormData = `${endpoint}/edit_item_data/`;
export const ticketDetailURL = (id) => `${endpoint}/ticket_manager/${id}`;
export const ticketUpdateDueDateURL = `${endpoint}/update_duedate/`;
export const ticketsListURL = `${endpoint}/list_ticket/`;
export const ticketsAllListURL = `${endpoint}/list_ticket_all/`;
export const ticketsAllList_SupADURL = `${endpoint}/list_ticket_all_SupAD/`;
export const ticketsPersonalListURL = `${endpoint}/list_ticket_personal/`;
export const getLoaiyeucauFormURL = (id) => `${endpoint}/template_form/${id}`;
export const createLoaiyeucauFormURL = `${endpoint}/template_form/`;
export const updateLoaiyeucauFormURL = (id) => `${endpoint}/template_form/${id}`;
export const AttachmentFileYeuCau = `${endpoint}/attachmentticketfile`;
export const ListStatusURL = `${endpoint}/list_ticketstatus/`;
export const ticketAddComment = `${endpoint}/ticket_comment`;
export const ticketAddCommentForReply = `${endpoint}/ticket_item_comment`;
export const usersListURL = `${endpoint}/list_user/`;
export const usersListURLV2 = `${endpoint}/list_user_v2/`; // 251224 tạo thay thế cho list_user
export const acceptTicketURL = `${endpoint}/accept_ticket/`;
export const cancelTicketURL = `${endpoint}/cancel_ticket/`;
export const assignTicketURL = `${endpoint}/assignment_ticket/`;
export const assignDeleteTicketURL = `${endpoint}/delete_assignment_ticket/`;
export const assignChangeTicketURL = `${endpoint}/change_assignment_ticket/`;
export const receiveTicketURL = `${endpoint}/receive_ticket/`;
export const forwardTicketURL = `${endpoint}/forward_ticket/`;
export const doneTicketURL = `${endpoint}/done_ticket/`;
export const reprocessTicketURL = `${endpoint}/reprocess_ticket/`;
export const closeTicketURL = `${endpoint}/close_ticket/`;
export const listLichsuthaydoi = (id) =>
  `${endpoint}/list_ticket_history/?ticket_id=${id}`;
export const ReadNotification = `${endpoint}/notification_read/`;
export const ReadAllNotificationURL = `${endpoint}/notification_read_all/`;
export const getPushNotificationURL = `${endpoint}/notification_is_sent/`;

export const exportExcelTempTicket = `${endpoint}/export_ticket_type_template`;
export const importExcelFormDataTicket = `${endpoint}/import_excel_ticket_form_data`;

export const changeStatusTicketURL = `${endpoint}/change_status_ticket/`; //190123

export const downloadFileManualURL = `${endpoint}/download-file-manual/`; // 050324

// Phần hệ thống tuyển dụng
export const url_detail_recruitment = (id) =>
  `${endpoint}/detail_recruitment/${id}`;
export const url_get_recruitment = `${endpoint}/list_recruitment/`;
export const url_get_list_department = `${endpoint}/list_department/`;
export const url_get_list_status_ticket = `${endpoint}/list_ticketstatus/`;
export const url_export_recruitment = `${endpoint}/export-recruitment/`;

// Phần QL ứng viên
export const url_get_list_status_cv = `${endpoint}/list_status_cv/`;
export const url_get_list_cv = `${endpoint}/list_cv/`;
export const url_get_detail_cv = (id) => `${endpoint}/detail_cv/${id}`;
export const url_change_status_cv = (id) =>
  `${endpoint}/change_status_cv/${id}`;
export const url_get_meeting_room = `${endpoint}/meeting_room/`;
export const url_get_regis_meeting = (id) => `${endpoint}/regis_meeting/${id}`;
export const url_regis_meeting = `${endpoint}/regis_meeting/`;
export const url_get_check_cv = (id) => `${endpoint}/check-cv/${id}`;
export const url_add_cv_interview = `${endpoint}/add-cv-interview/`;
export const url_note_cv = (id) => `${endpoint}/note-cv/${id}`;
export const url_add_note_cv = `${endpoint}/note-cv/`;
export const url_delete_file_cv = `${endpoint}/del-file-cv/`;
export const url_delete_data_cv = `${endpoint}/del-data-cv/`;
export const url_download_note_cv = (fileId) =>
  `${endpoint}/download-note-cv/${fileId}`;
export const url_export_cv = `${endpoint}/export-cv/`;

// Phần Lịch phỏng vấn
export const url_get_list_interview = `${endpoint}/list-interview/`;
export const url_regis_interview = `${endpoint}/regis-interview/`;
export const url_get_detail_interview = (id) =>
  `${endpoint}/regis-interview/${id}`;
export const url_check_cv_interview = (id) =>
  `${endpoint}/check-cv-interview/${id}`;

// Phần Chi tiết CV phỏng vấn
export const url_del_cv_interview = `${endpoint}/del-cv-interview/`;
export const url_detail_cv_interview = `${endpoint}/detail-cv-interview/`;

// Phần Báo cáo tuyển dụng
export const url_report_recruitment = `${endpoint}/report_rect/`;
export const url_export_rect = `${endpoint}/export_rect/`;

//List Tỉnh/Thành phố
export const url_get_list_city = `${endpoint}/list_city/`;
export const url_get_list_district = `${endpoint}/list_district/`;

// Form tạo CV của ứng viên

export const url_get_infor_input = `${endpoint}/infor_input/`;
export const url_post_form_create_cv = `${endpoint}/form_create_cv/`;
export const url_post_check_form_cv = `${endpoint}/check_form_cv/`;

export const url_get_list_team = `${endpoint}/list_team/`;
export const url_create_team = `${endpoint}/teammanager/`;
export const url_update_team = `${endpoint}/teammanager`;
export const url_team_lock = `${endpoint}/team_lock/`;

export const url_get_list_vanphong = `${endpoint}/list_vanphong/`;
export const url_create_vanphong = `${endpoint}/vanphongmanager/`;
export const url_update_vanphong = `${endpoint}/vanphongmanager`;

export const url_create_chucvu = `${endpoint}/chucvumanager/`;
export const url_update_chucvu = `${endpoint}/chucvumanager`;
export const url_list_position_permission = `${endpoint}/list_position_permission/`;

export const logoutHomeURL = "https://homepage.rainscales.com.vn/api/logout/";
